import React from 'react';
import PrivateRoute from '../hoc/PrivateRoute/PrivateRoute';
import ResumoMensalPage from '../pages/ControleBordero/ResumoMensal/ResumoMensalPage';
import MapaBorderoPage from '../pages/ControleBordero/MapaBordero/MapaBorderoPage';
import ControleEntradaPage from '../pages/ControleBordero/ControleEntrada/ControleEntradaPage';

function RoutesControleBorderoComponents() {
  return (
    <>
      <PrivateRoute
        path="/controle-de-bordero/controle-de-entrada"
        tipoUsuario="U"
        roles={['2301']}
        exact
        component={ControleEntradaPage}
      />
      <PrivateRoute
        path="/controle-de-bordero/mapa-bordero"
        tipoUsuario="U"
        roles={['2301']}
        exact
        component={MapaBorderoPage}
      />
      <PrivateRoute
        path="/controle-de-bordero/resumo-mensal"
        tipoUsuario="U"
        roles={['2302']}
        exact
        component={ResumoMensalPage}
      />
    </>
  );
}

export const RoutesControleBordero = RoutesControleBorderoComponents;
